<template>
  <div id="institucional">
    <img class="org" v-if="isMobile" src="../assets/organizacionMob.jpg" alt="organizacion">
    <img class="org" v-else src="../assets/organizacion.jpg" alt="organizacion">
  </div>
</template>

<script>
export default {
    props: {
        isMobile: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="scss" scoped>
    #institucional{
        width: 100%;
        max-width: 1000px;
        margin: 70px auto;
        text-align: center;
        .org{
            width: 100%;
            margin: auto;

            @media (max-width: var(--break-mobile)) {
                width: 95%;
            }
        }
    }
</style>